import { render } from "./ScenarioTwo.vue?vue&type=template&id=3e629260&scoped=true"
import script from "./ScenarioTwo.vue?vue&type=script&lang=js"
export * from "./ScenarioTwo.vue?vue&type=script&lang=js"

import "./ScenarioTwo.vue?vue&type=style&index=0&id=3e629260&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e629260"]])

export default __exports__